var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 40,
    viewBox: "0 0 20 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#AC6AFF",
    fillRule: "nonzero",
    points: "35.213 11.501 35.206 6.288 25.586 0 25.586 4.022 31.931 8.2 31.936 11.402 28.988 13.398 26.977 11.931 26.977 9.446 23.7 7.204 23.7 11.727 18.505 14.915 18.495 23.335 14.822 25.403 12.937 23.926 12.937 21.488 15.169 19.959 15.169 19.939 15.169 16.166 11.152 18.854 8.081 16.856 5.276 18.693 9.659 21.694 9.659 23.536 6.5 25.674 3.277 23.492 3.277 16.23 8.062 12.991 8.066 9.875 14.203 13.827 19.361 10.394 16.216 8.559 14.159 9.947 9.677 6.983 14.731 4.036 19.11 6.603 19.11 2.775 14.736 .211 4.794 6.008 4.787 11.223 0 14.465 0 25.257 4.787 28.499 4.794 33.714 14.414 40 14.414 35.981 8.069 31.803 8.064 28.601 11.012 26.605 13.023 28.072 13.023 30.557 16.3 32.798 16.3 28.275 21.569 25.088 21.628 16.667 25.178 14.599 27.063 16.076 27.063 18.514 24.831 20.043 24.831 20.063 24.831 23.837 28.848 21.148 31.919 23.146 34.724 21.309 30.34 18.306 30.34 16.466 33.5 14.329 36.723 16.511 36.723 23.772 31.939 27.012 31.934 30.127 25.797 26.173 20.639 29.584 23.784 31.416 25.841 30.055 30.323 33.019 25.269 35.966 20.89 33.399 20.89 37.225 25.264 39.789 35.206 33.995 35.213 28.779 40 25.537 40 14.743"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainwave);
export default __webpack_public_path__ + "static/media/brainwave.906dc98374de904a1031fa7cc3980fe3.svg";
export { ForwardRef as ReactComponent };